import { Text } from 'src/onboarding/components/typography/Text/Text';
import styles from './style.module.scss';
import { t } from '@web-solutions/module-localization';
import { Caption } from 'src/onboarding/components/typography/Caption/Caption';

import { useStore } from 'src/onboarding/store/store';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import yogurt from '../../../../assets/images/yogurtMeal.webp';
import beef from '../../../../assets/images/beefMeal.webp';
import toast from '../../../../assets/images/toastMeal.webp';
import tortilla from '../../../../assets/images/tortillaMeal.webp';
import { useRemoteConfig } from 'core/hooks/use-remote-config';

const MealPlanContainer = () => {
  const weight = useStore((state) => state.weight);
  const idealWeight = useStore((state) => state.idealWeight);

  const getWeightDifferenceText = (
    currentWeight: { type: string; lbs?: string; kg?: string },
    idealWeight: { type: string; value?: string; kg?: string }
  ) => {
    try {
      const currentValue = currentWeight.lbs || currentWeight.kg || '0';
      const idealValue = idealWeight.value || idealWeight.kg || '0';

      const current = Number(currentValue) || 0;
      const ideal = Number(idealValue) || 0;

      const difference = ideal - current;
      const absDifference = Math.abs(difference);
      const roundedDifference = Math.round(absDifference);

      const unit = currentWeight.type === 'lbs' ? 'lbs' : 'kg';

      if (difference > 1) {
        return t('onboarding.mealPlanContainer.gainWeight', {
          weight: roundedDifference,
          unit: unit,
        });
      } else if (difference < -1) {
        return t('onboarding.mealPlanContainer.loseWeight', {
          weight: roundedDifference,
          unit: unit,
        });
      } else {
        return t('onboarding.mealPlanContainer.maintainWeight');
      }
    } catch (error) {
      return t('onboarding.mealPlanContainer.maintainWeight');
    }
  };

  const weightText = getWeightDifferenceText(weight, idealWeight);

  return (
    <div className={styles.mealPlanContainer}>
      <div className={styles.mealPlanHeader}>
        <Title tag='h4' className={styles.eatTitle}>
          {weightText}
        </Title>
        <Text size='s' semibold className={styles.eatTitle}>
          {t('onboarding.mealPlanContainer.subTitle')}
        </Text>
      </div>
      <div className={styles.mealPlan}>
        {[
          {
            dishName: t('onboarding.mealPlanContainer.yogurtMeal.title'),
            image: yogurt,
            mealType: t('onboarding.mealPlanContainer.yogurtMeal.breakfast'),
            kcal: t('onboarding.mealPlanContainer.yogurtMeal.kcal'),
          },
          {
            dishName: t('onboarding.mealPlanContainer.beefMeal.title'),
            image: beef,
            mealType: t('onboarding.mealPlanContainer.beefMeal.lunch'),
            kcal: t('onboarding.mealPlanContainer.beefMeal.kcal'),
          },
          {
            dishName: t('onboarding.mealPlanContainer.toastMeal.title'),
            image: toast,
            mealType: t('onboarding.mealPlanContainer.toastMeal.snack'),
            kcal: t('onboarding.mealPlanContainer.toastMeal.kcal'),
          },
          {
            dishName: t('onboarding.mealPlanContainer.tortillaMeal.title'),
            image: tortilla,
            mealType: t('onboarding.mealPlanContainer.tortillaMeal.dinner'),
            kcal: t('onboarding.mealPlanContainer.tortillaMeal.kcal'),
          },
        ].map((item, idx) => (
          <div className={styles.card} key={idx}>
            <div className={styles.cardImage}>
              <img className={styles.image} src={item.image} alt='img' />
            </div>

            <Text size='m' bold className={styles.cardHeader}>
              {item.dishName}
            </Text>
            <div className={styles.mealDetails}>
              <Text size='s' semibold className={styles.mealType}>
                {item.mealType}
              </Text>
              <Caption size='l' className={styles.mealKcal}>
                {item.kcal}
              </Caption>
            </div>
          </div>
        ))}
      </div>
      <Caption size='m' className={styles.refunds}>
        {t('onboarding.mealPlanContainer.refunds')}
      </Caption>
    </div>
  );
};

export default MealPlanContainer;
